import * as React from 'react';
import { Box, Checkbox, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';

import { ReactComponent as ArrowRight } from 'assets/images/arrow_right_1.svg';
import { EOnboardingStep } from 'enums';
import { useOnboardingContext } from './onboarding.context.hook';
import { useZonesCount } from 'store/apis';

interface DialogPrevNextCloseProps {
  onPrev?: Function;
  onNext?: Function;
  onClose?: Function;
}

export const DialogPrevNextClose = ({ onPrev, onNext, onClose }: DialogPrevNextCloseProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [doNotShowAgain, setDoNotShowAgain] = React.useState<boolean>(false);
  const { updateOnboarding } = useOnboardingContext();
  const {
    data: { pending: pendingZonesCount },
  } = useZonesCount({ buildingId: null });

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', paddingY: 2 }}>
      {onPrev && (
        <Box sx={{ cursor: 'pointer' }} onClick={() => onPrev()}>
          <ArrowRight style={{ width: 32, color: theme.palette.primary.main, transform: 'rotate(180deg)' }} />
        </Box>
      )}

      {onNext && (
        <Box sx={{ cursor: 'pointer', marginLeft: onPrev ? 4 : 0 }} onClick={() => onNext()}>
          <ArrowRight style={{ width: 32, color: theme.palette.primary.main }} />
        </Box>
      )}

      {onClose && (
        <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Checkbox size="small" checked={doNotShowAgain} onChange={(_, checked) => setDoNotShowAgain(checked)} />
          <Typography color="textSecondary" variant="body2" sx={{ marginRight: down_sm ? 0.5 : 2 }}>
            Do not show again
          </Typography>

          <IconButton
            color="primary"
            onClick={() => {
              if (doNotShowAgain || pendingZonesCount > 0) {
                updateOnboarding({ status: EOnboardingStep.COMPLETED });
              }

              onClose();
            }}
          >
            <Close />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
